import React from 'react';
import {AppContext} from "../../HomePage";
import AuthBrandPanel from "./AuthBrandPanel";
import AuthLanguageSwitcher from "./AuthLanguageSwitcher";
import "./auth-ux.css";

// Shared shell for the signed-out screens. Screens render their own form only;
// the brand column, logo, headings and language switcher live here so all four
// stay consistent.
const AuthLayout = ({title, subtitle, children, footer}) => {

    const {host} = React.useContext(AppContext);

    // PriceRest's logo sits on the brand column, in its white-on-dark version.
    // eCOMSCANNER only has a dark logo, so for that host it stays on the card.
    const isWhiteLabel = host === "ecomscanner";

    return <div className="auth-ux">
        <AuthLanguageSwitcher/>
        <div className="auth-ux__brand">
            <AuthBrandPanel/>
        </div>
        <div className="auth-ux__panel">
            <div className="auth-ux__card">
                {isWhiteLabel &&
                <div className="auth-ux__logo">
                    <img src="/assets/layout/images/logo_ecomscanner.png" alt="eCOMSCANNER"/>
                </div>}
                <h1 className="auth-ux__title">{title}</h1>
                {subtitle && <p className="auth-ux__subtitle">{subtitle}</p>}
                {children}
                {footer && <div className="auth-ux__footer">{footer}</div>}
            </div>
        </div>
    </div>;
};
export default AuthLayout;
